import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import ShowMeButton from '../components/ShowMeButton.tsx';
import TaskCompleteButton from '../components/TaskCompleteButton.tsx';
import { CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/create-ideas/constants.tsx';
import { useActions, useCanCreateAndEditIdeas } from '../services/index.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './createIdeas.messages.tsx';
import { TASK_CREATE_IDEAS } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { setSpotlightStepId } = useActions();
	const canCreateAndEditIdeas = useCanCreateAndEditIdeas();

	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			{canCreateAndEditIdeas ? (
			<ShowMeButton onClick={() => setSpotlightStepId(CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID)} />
			) : (
				<TaskCompleteButton taskId={TASK_CREATE_IDEAS} />
			)}
		</TaskDescription>
	);
};

export const createIdeas = {
	id: TASK_CREATE_IDEAS,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
